module.exports = __webpack_public_path__ + "img/careers.e473b6c3.png";